module.exports = __webpack_public_path__ + "media/src/images/icons/note-f1413d50c4b9b1a3751eabee7c84eea0.svg";